// extracted by mini-css-extract-plugin
module.exports = {"container":"NotQualified_container___OgpJ","requirement":"NotQualified_requirement__fMsFY","disclaimer":"NotQualified_disclaimer__wb5CK"};